<style>
  #main {
  margin: 50px 0;
}

#main #faq .card {
margin-bottom: 30px;
border: 0 !important;
}

.card-header {
padding: 0.75rem 1.25rem;
margin-bottom: 0;
background-color: rgba(0, 0, 0, .03);
border-bottom: 0px !important;
}

#main #faq .card .card-header {
border: 0 !important;
border-bottom: 0px !important;
box-shadow: none !important;
border-radius: 2px;
padding: 0 !important;
}

.card-header:focus,
.card-header:active {
outline: none;
box-shadow: none;
}

.card .card-header .btn-header-link {
color: black;
display: block;
text-align: left;
font-size: 1rem;
font-weight: 600;
padding: 20px;
}

.btn-header-link:active,
.btn-header-link:focus {
box-shadow: none;
outline: none;
}

.card .card-header .btn-header-link::after {
content: url('/assets/images/arrow-up.svg');
font-family: 'Font Awesome' !important;
font-weight: 900;
float: right;
}

.card .card-header .btn-header-link.collapsed {
background: white;
color: black;
}

.card .card-header .btn-header-link.collapsed:after {
content: url('/assets/images/arrow-down.svg');
}

.card .collapsing {
background: white;
line-height: 30px;
}

.card .collapse {
border: 0 !important;
}

.card .collapse.show {
background: white;
line-height: 30px;
color: #222;
}

.card {
border: none !important;
border-radius: 12px !important;
}

.dark-backround {
background: none !important;
background-color: #171C31 !important;
}

.dark-backround input {
background: none !important;
background-color: #171C31 !important;
}
</style>


@for (item of details; track item; let i = $index) {
  <div class="card mb-3">
    <div class="card-header p-0" id="faqhead1">
      <a href="#" (click)="isCollapsed=i" class="btn btn-header-link collapsed py-4" data-toggle="collapse"
      aria-expanded="true">{{ item.title }}</a>
    </div>
    <div [attr.id]="'' + i" [collapse]="i!==isCollapsed" class="collapse">
      <div class="card-body" [innerHtml]="item.description">
      </div>
    </div>
  </div>
}